import Vue from 'vue'
import Vuex from 'vuex'
import modules from "./modules";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: navigator.language === "pt-BR",

  },
  getters: {
    popUpsIsVisible(state){
      return state.popus_visible
    },
    is_pt_br: state => {
      return navigator.language === "pt-BR"
    }
  },
  mutations: {},
  actions: {},
  modules
})
